<template></template>

<script>
  export default {
    name: 'integrations-shopify'
  }
</script>

<style module>
  body {
    background: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/js/pages/Shopify.vue